module.exports = {
  REACT_APP_API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  REACT_APP_S3_BUCKET_PRESIGN_URL: process.env.REACT_APP_S3_BUCKET_PRESIGN_URL,
  PORT: process.env.PORT
};
